<template>
  <div class="dynamic">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getData"
    >
      <div class="dynamic-content">
        <div class="title">下面是来自学员的真实反馈</div>
        <div class="dynamic-list">
          <DynamicItem
            class="dynamic-item"
            :data="item"
            v-for="(item, index) in dynamicList"
            :key="index"
          />
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import DynamicItem from './dynamic-item.vue'
export default {
  components: { DynamicItem },
  data() {
    return {
      dynamicList: [],
      loading: false,
      finished: false,
      page: 1
    }
  },
  created() {},
  methods: {
    async getData() {
      let params = {
        page: this.page,
        topic_id: 8
      }
      let res = await this.$http
        .getBaseApp('api/v2/Ugc/appTopicDetailPage', params)
        .catch(() => {
          this.loading = false
          this.finished = true
        })
      if (res) {
        this.loading = false
        res = res.data
        if (res.code == 200) {
          if (res.data.data.length) {
            this.dynamicList = this.dynamicList.concat(res.data.data)
            this.page++
          } else {
            this.finished = true
          }
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dynamic {
  .title {
    text-indent: 15px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
  }

  .dynamic-list {
    .dynamic-item {
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 16px;
      padding: 15px 16px;

      .d-top {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .d-avatar-c {
          position: relative;
          width: 36px;
          height: 36px;
          margin-right: 10px;

          .d-avatar {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }

          .d-flag {
            position: absolute;
            right: 0;
            bottom: 0;
            transform: translate(50%, 0%);
            width: 15px;
            height: 15px;
          }
        }

        .d-top-c {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;

          .nickname {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.8);
            line-height: 17px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .alias {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            color: rgba(0, 0, 0, 0.6);
            line-height: 17px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        .focus-btn {
          width: 64px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          background: rgba(98, 54, 255, 0.06);
          border-radius: 13px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: #6236ff;

          .iconfont {
            color: #6236ff;
            margin-right: 3px;
            font-weight: bold;
            font-size: 12px;
          }
        }

        .focus-btn-active {
          background: #f7f7f7;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
        }
      }

      .d-text {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
        margin-bottom: 16px;
      }

      .image-container {
        position: relative;
        margin-bottom: 4px;

        .image-list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .image-item {
            width: 100px;
            height: 100px;
            object-fit: cover;
            margin-right: 5px;
            margin-bottom: 5px;
            border-radius: 4px;
            overflow: hidden;
          }

          .image-item:nth-child(3n) {
            margin-right: 0px;
          }

          .image-item-one {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 240px;
          }
        }

        .image-num {
          position: absolute;
          right: 0;
          bottom: 5px;
          width: 30px;
          height: 30px;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 30px;
          text-align: center;
        }
      }

      .tag-list {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 16px;

        .tag-item {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #6236ff;
          line-height: 17px;
          margin-right: 10px;
        }

        .tag-item:last-child {
          margin-right: 0px;
        }
      }

      .operate-list {
        display: flex;
        align-items: center;

        .operate-item {
          margin-right: 18px;
          font-size: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: rgba(56, 61, 72, 0.5);
          line-height: 14px;

          .iconfont {
            color: rgba(203, 203, 203, 1);
            font-size: 14px;
            margin-right: 8px;
          }
        }

        .operate-item:last-child {
          margin-right: 0;
        }

        .operate-item-active {
          .iconfont {
            color: rgb(240, 70, 70);
          }
        }
      }
    }

    .dynamic-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
